module.exports = __webpack_public_path__ + "img/KubePi-red.174bb416.png";